import { createApiSlice } from "@common";
import {
  CRUD_PRODUCT_MODULE,
  CRUD_PRODUCT_MODULE_BY_ID
} from "@routes";

const apiConfig = [
  {
    name: "addProductModule",
    method: "post",
    url: CRUD_PRODUCT_MODULE,
    stateKey: "message"
  },
  {
    name: "getProductModuleById",
    method: "get",
    url: CRUD_PRODUCT_MODULE_BY_ID,
    stateKey: "data"
  },
  {
    name: "updateProductModule",
    method: "put",
    url: CRUD_PRODUCT_MODULE,
    stateKey: "message"
  },
  {
    name: "deleteProductModule",
    method: "delete",
    url: CRUD_PRODUCT_MODULE,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData:
      (state, action) => {
        state.additionalData = action.payload;
      },
    resetProductModule:
      (state) => {
        state.data = [];
      },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "productModule",
  apiConfig,
  customReducers);
const productModuleSlice = slice;

export default productModuleSlice.reducer;

export const {
  addProductModule,
  getProductModuleById,
  updateProductModule,
  deleteProductModule,
} = thunks;
export const {
  rowSelect,
  resetProductModule
} = actions;
